export { CompactTable } from './CompactTable'
